import React, { useState, useEffect, memo } from 'react';
import { MDBDataTable } from 'mdbreact';
import { mdbdatatable_config as config } from '../Const';
import { DatatableConvertedData } from '../types/ProjectListStaff';

interface Props {
  datas: Array<DatatableConvertedData>;
}

const MDBDatatable: React.FC<Props> = ({ datas }) => {
  const [columns, setColumns] = useState([
    {
      label: 'No.',
      field: 'no',
      sort: 'asc',
      width: 90,
    },
    {
      label: '担当店舗',
      field: 'branch_office_in_charge',
      sort: 'asc',
      width: 150,
    },
    {
      label: '申込No.',
      field: 'project_number',
      sort: 'asc',
      width: 200,
    },
    {
      label: '名前',
      field: 'name',
      sort: 'asc',
      width: 150,
    },
    {
      label: '口座番号',
      field: 'account_number',
      sort: 'asc',
      width: 150,
    },
    {
      label: 'ローン種類',
      field: 'fund_use',
      sort: 'asc',
      width: 150,
    },
    {
      label: '受付日',
      field: 'reception_date',
      sort: 'asc',
      width: 150,
    },
    {
      label: 'ステータス',
      field: 'status',
      sort: 'asc',
      width: 200,
    },
    {
      label: '事前審査諾否',
      field: 'pr_decision',
      sort: 'asc',
      width: 150,
    },
  ]);
  const [info_label, setInfoLabel] = useState(config.info_label.zero_rows);

  useEffect(() => {
    // infoLabelのプロパティを変更する
    if (datas.length > 0) {
      setInfoLabel(config.info_label.init);
    } else {
      setInfoLabel(config.info_label.zero_rows);
    }
  }, [datas]);

  return (
    <div id="mdb-datatable">
      <MDBDataTable
        className="project_list_for_staff_datatable"
        hover
        entriesOptions={[10, 50, 100]}
        entries={10}
        pagesAmount={4}
        data={{
          columns: columns,
          rows: datas,
        }}
        searching={false}
        infoLabel={info_label}
        entriesLabel=""
        noBottomColumns
        paginationLabel={['前', '次']}
        noRecordsFoundLabel="該当する情報が見つかりません"
        key="mdbdatatable"
      />
    </div>
  );
};

export default memo(MDBDatatable);
